import _ from 'lodash';
import { constants, breakpoints } from '../constants/index.js';

function getGreetingKey() {
    const {
        GREETING_KEYS: {
            MORNING_GREETING,
            AFTERNOON_GREETING,
            EVENING_GREETING
        }
    } = constants;

    const date = new Date()
    const currentHour = date.getHours();

    if (currentHour < 12) {
        return MORNING_GREETING
    } else if (currentHour < 18) {
        return AFTERNOON_GREETING
    } else {
        return EVENING_GREETING
    }
};

function getGreeting(options) {
    
    const { FIRST_NAME_PLACEHOLDER } = constants;
    const firstName = _.get(options, 'firstName', '');
    const greetingKey = getGreetingKey();
    const greeting = _.replace(options[greetingKey], FIRST_NAME_PLACEHOLDER, firstName) 
    
    return greeting; 
}

function getHeightParams (width) {
    let marginOffset = 17;
    let viewportMultiplier = 0.65;

    if (width > breakpoints.md) {
        marginOffset = 10;
        viewportMultiplier = 0.85;
    }

    if (width > breakpoints.lg) {
        marginOffset = 24;
        viewportMultiplier = 0.9;
    };

    if (width > breakpoints.xl) {
        marginOffset = 24;
        viewportMultiplier = 0.95;
    };

    if (width > breakpoints.xxl) {
        marginOffset = 24;
        viewportMultiplier = 1;
    };

    return {marginOffset, viewportMultiplier }
};

export { 
    getGreeting,
    getHeightParams,
}